import ClientConfig from "../configuration/client_config.json";

class AmbassadorHelper{
    getDisplayName(ambassador){
        const storefront_details = this.getStoreFrontDetails(ambassador);
        const displayName = (storefront_details && storefront_details.display_name)
            ? storefront_details.display_name : ambassador.profileTitle;
        return displayName;
    }
    getDisplayNameFromApi(ambassador){
        if(!ambassador) return "";
        const storefront_details = ambassador.storefront_details || {};
        const displayName = (storefront_details && storefront_details.display_name)
            ? storefront_details.display_name : `${ambassador.first_name} ${ambassador.last_name}`;
        return displayName;
    }
    getStoreFrontDetails(ambassador) {
        if (ambassador && ambassador.data && ambassador.data.storefront_details)
            return ambassador.data.storefront_details
        else return {}
    }
    getImages = (ambassador) => {
        if (ambassador && ambassador.data && ambassador.data.images)
            return ambassador.data.images;
        else if (ambassador && ambassador.images)
            return ambassador.images;
        else return false;
    }
    pickImageVariant = (variants, minWidth) => {
        const keys = Object.keys(variants)
            .map(key => ({key, width: parseInt(key, 10)}))
            .filter(entry => !isNaN(entry.width))
            .sort((a, b) => a.width - b.width);
        if (!keys.length) {
            const values = Object.values(variants);
            return values[values.length - 1];
        }
        if (!minWidth) return variants[keys[keys.length - 1].key];
        const match = keys.find(entry => entry.width >= minWidth) || keys[keys.length - 1];
        return variants[match.key];
    }
    getAmbassadorCover = (ambassador, minWidth) => {
        const images = this.getImages(ambassador);
        if (images && images.cover) {
            return this.pickImageVariant(images.cover, minWidth);
        } else {
            return this.clientConfigAmbassador().default_profile_cover_url;
        }
    }
    clientConfigAmbassador(){
        if(ClientConfig && ClientConfig.client_config.client && ClientConfig.client_config.client.ambassador){
            return ClientConfig.client_config.client.ambassador;
        }
        else
            return {}
    }
    getAmbassadorPhoto = (ambassador, minWidth) => {
        const images = this.getImages(ambassador);
        if (images && images.photo) {
            return this.pickImageVariant(images.photo, minWidth);
        } else if (ambassador && ambassador.data && ambassador.data.profilePhoto) {
            return this.validateProfileUrl(ambassador.data.profilePhoto);
        } else {
            return this.clientConfigAmbassador().default_profile_photo_url;
        }
    }
    getCreatorPhoto = (creator) => {
        if (creator?.thumbnail) {
            return creator.thumbnail;
        } else {
            return this.clientConfigAmbassador().default_profile_photo_url;
        }
    }
    getAmbassadorPhotoFromApi = (ambassador, minWidth) => {
        const images = ambassador.images || false;
        if (images && images.photo) {
            return this.pickImageVariant(images.photo, minWidth);
        } else if (ambassador && ambassador.profile_picture) {
            return this.validateProfileUrl(ambassador.profile_picture);
        } else {
            return this.clientConfigAmbassador().default_profile_photo_url;
        }
    }
    validateProfileUrl(profilePhoto){
        if (profilePhoto && profilePhoto.indexOf("http") === -1)
            return `https://api.tvpage.com${profilePhoto}`;
        else if(profilePhoto){
            return profilePhoto;
        }
    }
    getCreatorBio = (ambassador) => {
        if(ambassador?.social_profile?.bio){
            return ambassador.social_profile.bio
        }else{
            return this.clientSection().ambassador_program_default_bio;
        }
    }
    clientSection(){
        if(ClientConfig && ClientConfig.client_config.client){
            return ClientConfig.client_config.client;
        }
        else
            return {}
    }
}

export default new AmbassadorHelper;